module.exports = __webpack_public_path__ + "img/laboratorio2_3-4_1152.6fdd0bfd.webp";